import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'

import Rail from 'components/Rail'
import styles from './RailLeft.module.sass'
import { actions } from 'modules/home/HomeReducer'
import {
  getLoadingCurricula,
  getLoadingPodcasts,
  getLoadingEvents,
  getSpecialtyInput,
  getCurricula,
  getPodcasts,
  getEvents,
  getMediaUrlPSource
} from 'modules/home/HomeSelector'
import {
  getIsLogin,
  getProfile,
  getHasPartyId
} from 'modules/auth/AuthSelector'
import { getProfileInfo } from 'utils'

const expire_delay = 4 * 60 * 60 * 1000 // Miliseconds in 2 hours

const RailLeft = () => {
  const dispatch = useDispatch()

  const [curricula, setCurricula] = useState([])
  const [podcast, setPodcast] = useState([])
  const [event, setEvent] = useState([])

  const loadingCurricula = useSelector(getLoadingCurricula)
  const loadingPodcasts = useSelector(getLoadingPodcasts)
  const loadingEvents = useSelector(getLoadingEvents)
  const dataCurricula = useSelector(getCurricula)
  const dataPodcast = useSelector(getPodcasts)
  const dataEvent = useSelector(getEvents)

  useEffect(() => {
    dispatch(actions.requestCurricula())
    dispatch(actions.requestPodcasts())
    dispatch(actions.requestEvents())
  }, [dispatch])

  // Specialty
  const specialtyInput = useSelector(getSpecialtyInput)

  useEffect(() => {
    setCurricula(
      dataCurricula?.filter(f =>
        f.specialties.includes(specialtyInput.label)
      ) ?? []
    )
    setPodcast(
      dataPodcast?.filter(f => f.specialties.includes(specialtyInput.label)) ??
        []
    )
    setEvent(
      dataEvent
        ?.filter(f => f.specialties.includes(specialtyInput.label))
        .filter(f => Date.now() - new Date(f.dates[0]).getTime() < expire_delay)
        .sort(
          (a, b) =>
            new Date(a.dates[0]).getTime() - new Date(b.dates[0]).getTime()
        ) ?? []
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, dataCurricula, dataPodcast, dataEvent, specialtyInput.value])

  const mediaUrlPSource = useSelector(getMediaUrlPSource)
  const hasPartyId = useSelector(getHasPartyId)
  const isLoggedIn = useSelector(getIsLogin)
  const profile = useSelector(getProfile)
  let [urlParams, setUrlParams] = useState(
    `?SpecialtyID=&AudienceID=aicme&PromoCode=796${
      mediaUrlPSource ? JSON.stringify(mediaUrlPSource).replaceAll('"', '') : ''
    }`
  )
  useEffect(() => {
    if (isLoggedIn && profile) {
      const {
        partyId,
        partyEmailId,
        professionId,
        specialtyId
      } = getProfileInfo(profile)
      setUrlParams(
        `?MemberID=${partyId}&EmailID=${partyEmailId}&ProfessionID=${professionId}&SpecialtyID=${specialtyId}&AudienceID=aicme&PromoCode=796`
      )
    } else if (hasPartyId && profile) {
      const { partyId } = getProfileInfo(profile)
      setUrlParams(
        `?MemberID=${partyId}&AudienceID=aicme&PromoCode=796${
          mediaUrlPSource
            ? JSON.stringify(mediaUrlPSource).replaceAll('"', '')
            : ''
        }`
      )
    }
  }, [isLoggedIn, hasPartyId, profile, mediaUrlPSource])

  return (
    <Rail styles={styles}>
      <div className={styles.content}>
        <div className={styles.menu}>
          <p className={styles.menuTitle}>CURRICULA</p>
        </div>
        <div className={styles.menuC}>
          {loadingCurricula ? (
            <Skeleton
              count={3}
              height={35}
              baseColor="#e2eaf5"
              highlightColor="#fbfdff"
              style={{ marginBottom: '20px' }}
            />
          ) : (
            <>
              <p className={styles.menuText} style={{ paddingBottom: '19px' }}>
                A curriculum is a series of related courses
              </p>
              {curricula.map(({ title, url }) => (
                <a
                  href={url + urlParams}
                  key={title}
                  target="_blank"
                  rel="noreferrer"
                >
                  <p
                    dangerouslySetInnerHTML={{ __html: title }}
                    className={styles.link}
                  />
                </a>
              ))}
              <Link
                to="/curricula"
                className={styles.moreLink}
                onClick={() => {
                  dispatch(actions.setSearchTerm(''))
                  dispatch(actions.setSearchPanel(false))
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    dispatch(actions.setSearchTerm(''))
                    dispatch(actions.setSearchPanel(false))
                  }
                }}
              >
                <p className={styles.moreText}>View More</p>
                <p style={{ height: '22px' }}>&nbsp;</p>
              </Link>
            </>
          )}
        </div>
        <div className={styles.menu}>
          <p className={styles.menuTitle}>PODCASTS</p>
        </div>
        <div className={styles.menuC}>
          {loadingPodcasts ? (
            <Skeleton
              count={3}
              height={35}
              baseColor="#e2eaf5"
              highlightColor="#fbfdff"
              style={{ marginBottom: '20px' }}
            />
          ) : (
            <>
              {podcast.map(({ channel, distributions }) => (
                <div key={channel} className={styles.span}>
                  <p className={styles.menuText}>
                    <b>{channel}</b>
                  </p>
                  {distributions
                    .map(({ name, url }) => (
                      <a
                        key={name}
                        href={url}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.link}
                      >
                        {name}
                      </a>
                    ))
                    .reduce((prev, curr) => [prev, ' | ', curr])}
                </div>
              ))}
              <Link
                to="/podcasts"
                className={styles.moreLink}
                onClick={() => {
                  dispatch(actions.setSearchTerm(''))
                  dispatch(actions.setSearchPanel(false))
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    dispatch(actions.setSearchTerm(''))
                    dispatch(actions.setSearchPanel(false))
                  }
                }}
              >
                <p className={styles.moreText}>View More</p>
                <p style={{ height: '22px' }}>&nbsp;</p>
              </Link>
            </>
          )}
        </div>
        <div className={styles.menu}>
          <p className={styles.menuTitle}>LIVE EVENTS</p>
        </div>
        <div className={styles.menuC}>
          {loadingEvents ? (
            <Skeleton
              count={3}
              height={35}
              baseColor="#e2eaf5"
              highlightColor="#fbfdff"
              style={{ marginBottom: '20px' }}
            />
          ) : (
            <>
              {event.map(({ title, url, dates, format, location, credit }) => (
                <div key={title}>
                  <a href={url + urlParams} target="_blank" rel="noreferrer">
                    <p
                      dangerouslySetInnerHTML={{ __html: title }}
                      className={styles.link}
                      style={{ marginBottom: '6px' }}
                    />
                  </a>
                  {dates && (
                    <p className={styles.title}>
                      Date:{' '}
                      <span
                        className={styles.info}
                        style={{ whiteSpace: 'pre-line' }}
                      >
                        {dates.join(`\n`)}
                      </span>
                    </p>
                  )}
                  {location && (
                    <p className={styles.title}>
                      Location: <span className={styles.info}>{location}</span>
                    </p>
                  )}
                  {credit && (
                    <p
                      className={styles.title}
                      style={{ marginBottom: '19px' }}
                    >
                      Credit: <span className={styles.info}>{credit}</span>
                    </p>
                  )}
                </div>
              ))}
              <Link
                to="/live-events"
                className={styles.moreLink}
                onClick={() => {
                  dispatch(actions.setSearchTerm(''))
                  dispatch(actions.setSearchPanel(false))
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    dispatch(actions.setSearchTerm(''))
                    dispatch(actions.setSearchPanel(false))
                  }
                }}
              >
                <p className={styles.moreText}>View More</p>
                <p style={{ height: '22px' }}>&nbsp;</p>
              </Link>
            </>
          )}
        </div>
      </div>
    </Rail>
  )
}

export default RailLeft
